import { render, staticRenderFns } from "./cuShiGuan.vue?vue&type=template&id=543f6988&scoped=true"
import script from "./cuShiGuan.vue?vue&type=script&lang=js"
export * from "./cuShiGuan.vue?vue&type=script&lang=js"
import style0 from "./cuShiGuan.vue?vue&type=style&index=0&id=543f6988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543f6988",
  null
  
)

export default component.exports